{
  "EN": {
    "existingUserMessage": "We've added a few quick questions to help us serve you better. It won't take long. Thanks for updating your info!",
    "personalDetails": "Personal details",
    "academicDetails": "Academic details",
    "englishProficiency": "English proficiency",
    "otherDetails": "Other details",
    "reviewDetails": "Review details"
  },
  "ID_IND": {
    "existingUserMessage": "Kami menambahkan beberapa pertanyaan singkat untuk melayani Anda lebih baik. Terima kasih!",
    "personalDetails": "Data pribadi",
    "academicDetails": "Data akademik",
    "englishProficiency": "Kemampuan bahasa Inggris",
    "otherDetails": "Data lainnya",
    "reviewDetails": "Tinjau data"
  },
  "TH_THA": {
    "existingUserMessage": "เราเพิ่มคำถามสั้น ๆ เพื่อให้บริการคุณได้ดียิ่งขึ้น ขอบคุณที่อัปเดตข้อมูล",
    "personalDetails": "ข้อมูลส่วนบุคคล",
    "academicDetails": "ข้อมูลการศึกษา",
    "englishProficiency": "ความสามารถภาษาอังกฤษ",
    "otherDetails": "ข้อมูลอื่น ๆ",
    "reviewDetails": "ตรวจสอบข้อมูล"
  },
  "KR_KOR": {
    "existingUserMessage": "더 나은 서비스를 위해 몇 가지 질문을 추가했습니다. 잠시만 시간을 내주세요!",
    "personalDetails": "개인 정보",
    "academicDetails": "학업 정보",
    "englishProficiency": "영어 능력",
    "otherDetails": "기타 정보",
    "reviewDetails": "정보 확인"
  },
  "TW_CHI": {
    "existingUserMessage": "我們增加了幾個簡單問題以提供更好服務，感謝更新資料！",
    "personalDetails": "個人資料",
    "academicDetails": "學歷資料",
    "englishProficiency": "英語能力",
    "otherDetails": "其他資料",
    "reviewDetails": "確認資料"
  },
  "HK_CHI": {
    "existingUserMessage": "我們新增了幾個簡短問題，以便更好為您服務，感謝更新資料！",
    "personalDetails": "個人資料",
    "academicDetails": "學歷資料",
    "englishProficiency": "英語水平",
    "otherDetails": "其他資料",
    "reviewDetails": "確認資料"
  },
  "HK_ZK": {
    "existingUserMessage": "我们添加了一些简短问题，帮助我们更好地为您服务。不会花太多时间，谢谢更新信息！",
    "personalDetails": "个人信息",
    "academicDetails": "学业信息",
    "englishProficiency": "英语水平",
    "otherDetails": "其他信息",
    "reviewDetails": "确认信息"
  }
}
